(() => {
  if (customElements.get('ingredients-media')) {
    return;
  }

  class IngredientsMedia extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.count = Number(this.dataset.count) || 0;
      this.currentIndex = 0;
      this.sectionTop = 0;
      this.sectionHeight = 0;
      this.scrollRaf = null;
      this.headerGroup = document.querySelector('.header-group');

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.runScrollFrame = this.runScrollFrame.bind(this);
    }

    connectedCallback() {
      this.initSlider();

      if (this.count > 1 && this.slider) {
        this.calculateMetrics();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.updateSlide(true);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.scrollRaf) {
        cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = null;
      }
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement || typeof Swiper === 'undefined') return;

      this.options = {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        allowTouchMove: true,
        fadeEffect: {
          crossFade: true
        },
      };

      this.slider = new Swiper(sliderElement, this.options);
      this.slider.slideTo(0, 0);
    }

    calculateMetrics() {
      const rect = this.getBoundingClientRect();
      this.sectionTop = rect.top + window.scrollY;
      this.sectionHeight = Math.max(rect.height, this.scrollHeight, 1);
    }

    handleResize() {
      this.calculateMetrics();
      if (this.slider) {
        this.slider.update();
      }
      this.updateSlide(true);
    }

    handleScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(this.runScrollFrame);
    }

    runScrollFrame() {
      this.scrollRaf = null;
      this.updateSlide();
    }

    updateSlide(force = false) {
      if (!this.slider || this.count <= 1 || !this.sectionHeight || window.innerWidth > 767) return;

      const scrollRelative = window.scrollY - this.sectionTop - this.headerGroup.offsetHeight;
      const progress = Math.min(1, Math.max(0, scrollRelative / this.sectionHeight));
      const targetIndex = Math.min(this.count - 1, Math.floor(progress * this.count));

      if (force || targetIndex !== this.currentIndex) {
        this.currentIndex = targetIndex;
        this.slider.slideTo(targetIndex);
      }
    }
  }

  customElements.define('ingredients-media', IngredientsMedia);
})();
